/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Ways the solicitor can conduct consultations
 */
export enum ConsultationChannel {
    IN_PERSON = 'IN_PERSON',
    PHONE = 'PHONE',
    VIDEO = 'VIDEO',
    HOME_VISITS = 'HOME_VISITS',
}
